module.exports = __webpack_public_path__ + "plus.6312170bdfed20e0293b.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/plus.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/plus.svg
// module chunks = styles